import type { InsightsSummaryProps } from '@shared/widget-schemas';

import { DashboardKpiStrip } from '@/components/v2/shared/DashboardKpiStrip';
import { KpiCard } from '@/components/v2/shared/KpiCard';
import { capitalizeFirst } from './textFormat';

function insightIconClass(confidence: number): string {
  if (confidence >= 0.7) return 'text-emerald-400';
  if (confidence >= 0.4) return 'text-amber-400';
  return 'text-red-400';
}

export function InsightsSummaryWidget({ insights }: InsightsSummaryProps) {
  return (
    <DashboardKpiStrip className="w-full">
      {insights.map((insight, i) => (
        <KpiCard
          key={i}
          variant="insight"
          iconClassName={insightIconClass(insight.confidence)}
          value={`${Math.round(insight.confidence * 100)}%`}
          label={capitalizeFirst(insight.label)}
        />
      ))}
    </DashboardKpiStrip>
  );
}
